import { render, staticRenderFns } from "./OrganizationSchools.vue?vue&type=template&id=27dc7aee&scoped=true&"
import script from "./OrganizationSchools.vue?vue&type=script&lang=js&"
export * from "./OrganizationSchools.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSchools.vue?vue&type=style&index=0&id=27dc7aee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc7aee",
  null
  
)

export default component.exports